import { type FullMode } from 'core/domain/Mode'
import { type ListResults } from 'core/domain/Request'
import { createDate } from 'core/utils/date'

import { type EquipmentType } from '../../core/domain/EquipmentType'
import { type Shipper, type ShipperDetail } from '../domain/shippers'

export type RawShipper = {
  name: string
  shipper_uuid: string
  bids_through: string | null
  approval_status: string
  carrier_added_at: string
  last_shipment_at: string | null
}

export type RawShippersResponse = ListResults<RawShipper>
export type RawShipperDetail = {
  uuid: string
  company_name: string
  address: string | null
  city: string | null
  state: string | null
  country: string | null
  zipcode: string | null
  bids_through: string | null
  carrier_added_at: string
  modes: string[]
  equipment_types: string[]
}

export function mapApiToShipper(raw: RawShipper): Shipper {
  return {
    id: raw.shipper_uuid,
    name: raw.name,
    carrierAddedAt: new Date(raw.carrier_added_at),
    lastShipmentAt: createDate(raw.last_shipment_at) ?? undefined,
    bidsThroughEnabled: raw.bids_through !== null && raw.bids_through !== '',
    approvalStatus: raw.approval_status,
  }
}

export function mapApiToShippers(response: RawShippersResponse): {
  shippers: Shipper[]
  totalCount: number
} {
  return {
    shippers: response.results.map(mapApiToShipper),
    totalCount: response.count,
  }
}

export function mapApiToShipperDetail(raw: RawShipperDetail): ShipperDetail {
  return {
    uuid: raw.uuid,
    companyName: raw.company_name,
    address: raw.address || undefined,
    city: raw.city || undefined,
    state: raw.state || undefined,
    country: raw.country || undefined,
    zipcode: raw.zipcode || undefined,
    bidsThroughEnabled: raw.bids_through !== null && raw.bids_through !== '',
    carrierAddedAt: new Date(raw.carrier_added_at),
    modes: raw.modes as FullMode[],
    equipmentTypes: raw.equipment_types as EquipmentType[],
  }
}
